import { createRateLimitedRequest, watchRequest } from '@services/api/utils'
import { type WatchRequestConfig } from '@services/api/declarations'
import { type ClubGroupLegacy } from '@libs/fsc/types/legacy'

import { getLegacyPeopleGroupByClubConfig, getUserLegacyLogoutConfig } from '@services/Legacy/api'
import { useApiLegacyStore } from '@services/Legacy/store'

const serviceName = 'Legacy'

export function useApiLegacyRequest() {
  const apiLegacyStore = useApiLegacyStore()
  const { sendRequest } = apiLegacyStore

  // GET LEGACY LOGOUT
  function fetchGetUserLegacyLogout() {
    createRateLimitedRequest({
      sendRequest,
      endpoint: getUserLegacyLogoutConfig,
      serviceName,
      endpointName: 'legacyClient',
    })
  }

  // GET LEGACY PEOPLE GROUP BY CLUB
  function fetchGetLegacyPeopleGroupByClub() {
    createRateLimitedRequest({
      sendRequest,
      endpoint: getLegacyPeopleGroupByClubConfig,
      serviceName,
      endpointName: 'legacy',
    })
  }

  function watchGetLegacyPeopleGroupByClub(
    { onSuccess, onError }: WatchRequestConfig<ClubGroupLegacy>,
  ) {
    const { closeSubscription } = watchRequest<ClubGroupLegacy>(
      getLegacyPeopleGroupByClubConfig,
      {
        onSuccess: (data) => onSuccess?.(data),
        onError: (error) => onError?.(error),
      },
    )

    return { closeSubscription }
  }

  return {
    fetchGetUserLegacyLogout,
    fetchGetLegacyPeopleGroupByClub,
    watchGetLegacyPeopleGroupByClub,
  }
}
